export default "__VITE_ASSET__IaePzGtI__"